import { render, staticRenderFns } from "./TheModalHonorarioMedico.vue?vue&type=template&id=8c610800&scoped=true&"
import script from "./TheModalHonorarioMedico.vue?vue&type=script&lang=js&"
export * from "./TheModalHonorarioMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c610800",
  null
  
)

export default component.exports